__turbopack_context__.v({
  "gamesCount": "advanced-sidebar-live-module-sass-module__UiOdBW__gamesCount" + " " + __turbopack_context__.i(402915)["gamesCount"],
  "liveSportItem": "advanced-sidebar-live-module-sass-module__UiOdBW__liveSportItem" + " " + __turbopack_context__.i(402915)["sportsNavItem"],
  "selected": "advanced-sidebar-live-module-sass-module__UiOdBW__selected",
  "sportsNav": "advanced-sidebar-live-module-sass-module__UiOdBW__sportsNav" + " " + __turbopack_context__.i(286078)["sportsNav"],
});
